module.exports = __webpack_public_path__ + "img/img10.feb2181a.png";